const ENDPOINTS = {
  // =========================== Public =========================
  // ============================================================

  GENERAL_SETTINGS: "/api/general-setting",
  MAINTENANCE_STATUS: "/api/maintenance-status",
  SEO: "/api/seo",
  GET_EXTENSION: "/api/get-extension",
  LOGIN: "/api/login",
  AUTH_RESEND_OTP: (email) => `/api/register/resend-code/${email}`,
  AUTH_VERIFY_OTP: "/api/auth/verify-otp",
  AUTH_REFRESH: "/api/refresh",
  ENCRYPT_PAYLOAD: "/api/encrypt",
  LOGOUT: "/api/logout",

  REGISTER_STEP_1: "/api/register/step-1",
  REGISTER_STEP_1_POST: "/api/register/step-1",
  // REGISTER_STEP_2: "/api/register/step-2",
  REGISTER_STEP_3: "/api/register/step-3",
  REGISTER_STEP_3_POST: "/api/register/step-3",

  RESET_EMAIL: "/api/password/email",
  RESET_EMAIL_VERIFICATION: "/api/password/verify-code",
  RESET_PASSWORD: "/api/password/reset",
  LANG_KEYS: "/api/language",
  POLICY_PAGES: "/api/policies",
  POLICY: "/api/policy",
  COUNTRIES: "/api/get-countries",
  ALL_SECTIONS: "/api/sections",
  SUBSCRIBE: "/api/subscribe",
  CONTACT_US: "/api/contact/submit",
  CONTACT_SUBMIT_MAIL: "/api/contact/submit-email",
  COOKIE: "/api/cookie",
  CUSTOM_PAGES: "/api/custom-pages",
  CUSTOM_PAGE: "/api/custom-page",
  FOOTER_PAGE: "/api/footer-page",
  FOOTER_MENUS: "/api/footer-menus",
  TERMS_AND_CONDITION: "/api/terms-and-condition",

  BLOGS: "/api/blogs",
  BLOG_DETAILS: "/api/blog-details",

  JOBS: "/api/jobs",
  JOB_DETAILS: "/api/job-details",

  EXCHANGE_DATA: "/api/exchange-data",
  EXCHANGE_CHART_DATA: "/api/exchange-chart-data",
  NAME_ENQUIRY: "/api/name-enquiry",

  // =========================== Ticket API =====================
  // ============================================================

  TICKETS: "/api/tickets", // Get all tickets
  CREATE_TICKET: "/api/tickets", // Create a new ticket
  VIEW_TICKET: "/api/tickets", // Get ticket details (replace {ticket} with actual ID)
  REPLY_TICKET: "/api/tickets/reply", // Reply to a ticket
  CLOSE_TICKET: "/api/tickets/close", // Close a ticket
  DOWNLOAD_TICKET_ATTACHMENT: "/api/tickets/download", // Download attachment (replace {attachment} with ID)

  // =========================== User ===========================
  // ============================================================

  DASHBOARD: "/api/user/dashboard",
  PRICING_PLANS: "/api/v2/plans",
  SUBSCRIPTION_CURRENT: "/api/v2/subscription",
  SUBSCRIPTION_USAGE: "/api/v2/subscription/usage",
  SUBSCRIPTION_THRESHOLD_CHECK: "/api/v2/subscription/threshold-check",
  SUBSCRIPTION_HISTORY: "/api/v2/subscription/history",
  SUBSCRIPTION_SUBSCRIBE: "/api/v2/subscription/subscribe",
  SUBSCRIPTION_UPGRADE: "/api/v2/subscription/upgrade",
  /** Immediate plan downgrade (billing wallet required in body as `wallet_id`). */
  SUBSCRIPTION_DOWNGRADE: "/api/v2/subscription/downgrade-immediate",
  SUBSCRIPTION_RESUBSCRIBE: "/api/v2/subscription/resubscribe",
  SUBSCRIPTION_RESUBSCRIBE_CUSTOM: "/api/v2/subscription/resubscribe-custom",
  SUBSCRIPTION_RENEW: "/api/v2/subscription/renew",
  SUBSCRIPTION_RECEIPT: (subscriptionId, renewalId) =>
    `/api/v2/subscription/show/${subscriptionId}/${renewalId}/receipt`,
  USER_INFO: "/api/user/get-user-info",
  UPDATE_USER_DATA: "/api/user-data-submit",

  // Questionnaire endpoints
  QUESTIONNAIRE_ALL: "/api/user/get-questionnaires",
  QUESTIONNAIRE_GET: "/api/user/get-questionnaire",
  QUESTIONNAIRE_SUBMIT: "/api/user/submit-questionnaire-response",
  UPDATE_PROFILE: "/api/user/profile-setting",
  CHANGE_PASSWORD: "/api/user/change-password",
  CLOSE_ACCOUNT: "/api/user/close-account",

  TWO_FA_SETUP: "/api/user/twofactor",
  TWO_FA_ENABLE: "/api/user/twofactor/enable",
  TWO_FA_DISABLE: "/api/user/twofactor/disable",

  AUTHORIZATION: "/api/user/authorization",
  AUTHORIZATION_RESEND_CODE: "/api/user/authorization/resend-code",
  AUTHORIZATION_VERIFY_EMAIL: "/api/user/authorization/verify-email",

  REQUEST_OTP: "/api/security/login-otp/setup",
  OTP_ENABLE: "/api/user/security/otp/enable",
  OTP_DISABLE: "/api/user/security/otp/disable",

  INBOX: "/api/user/inbox",
  NOTIFICATIONS: "/api/user/notifications",
  PARTIAL_NOTIFICATIONS: "/api/user/partial/notifications",
  NOTIFICATION_DETAILS: "/api/user/notification/details",
  NOTIFICATION_READ_ALL: "/api/user/notification/read-all",

  WITHDRAW_HISTORY: "/api/withdraw/history",
  WITHDRAWAL_METHODS: "/api/withdraw-method",
  WITHDRAW_REQUEST: "/api/withdraw-request",
  WITHDRAW_CONFIRM: "/api/withdraw-request/confirm",
  KYC_FORM: "/api/user/kyc-form",
  KYC_SUBMIT: "/api/kyc-submit",
  KYC_DATA: "/api/kyc-data",
  DOWNLOAD_FILE: "/api/download-attachments",
  PAYMENT_METHODS: "/api/deposit/methods",
  PAYMENT_REQUEST: "/api/deposit/insert",

  APP_DEPOSIT_DATA: "/api/user/app/deposit/data",
  DEPOSIT_HISTORY: "/api/deposit/history",
  MANUAL_DEPOSIT: "/api/user/deposit/manual",
  MANUAL_DEPOSIT_CONFIRM: "/api/user/deposit/manual/confirm",

  SOCIAL_LOGIN: "/api/social-login",
  FCM_STORE_TOKEN: "/api/add-device-token",

  TRANSACTIONS: "/api/user/transactions",
  FILTER_TRANSACTIONS: "/api/user/filter/transactions",
  TRANSACTION_DETAILS: "/api/user/transaction/details",
  TRANSACTION_DOWNLOAD: "/api/user/transaction/download",
  REPORT_TRANSACTION: "/api/user/report-transaction",
  TRANSACTION_LIMIT: "/api/user/transaction-limit",

  DOCUMENT_VERIFICATION: "/api/user/document-verification",

  MY_REFERRALS: "/api/user/referrals",
  MY_BONUS: "/api/user/bonus-point",
  BONUS_POINT_HISTORY: "/api/user/bonus-point/history",

  MY_RECIPIENTS: "/api/user/recipients",
  DELETE_RECIPIENT: "/api/user/delete/recipient",

  SEND_MONEY_STEP_1: "/api/user/send-money/step-1",
  SEND_MONEY_STEP_1_POST: "/api/user/send-money/step-1",

  SEND_MONEY_STEP_2: "/api/user/send-money/step-2",
  SEND_MONEY_STEP_2_POST: "/api/user/send-money/step-2",

  SEND_MONEY_STEP_3: "/api/user/send-money/step-3",
  SEND_MONEY_STEP_3_POST: "/api/user/send-money/step-3",

  SEND_MONEY_STEP_4: "/api/user/send-money/step-4",
  SEND_MONEY_STEP_4_POST: "/api/user/send-money/step-4",

  SEND_MONEY_STEP_5: "/api/user/send-money/step-5",
  SEND_MONEY_STEP_5_POST: "/api/user/send-money/step-5",

  SEND_MONEY_APPLY_COUPON: "/api/user/send-money/apply-coupon",
  SEND_MONEY_REMOVE_COUPON: "/api/user/send-money/remove-coupon",

  SEND_MONEY_REPEAT: "/api/user/send-money/repeat",
  SEND_MONEY_REPEAT_POST: "/api/user/send-money/repeat",

  SEND_MONEY_DOCUMENT_SUBMIT: "/api/user/send-money/document/submit",

  FUND_WALLET_STEP_1: "/api/user/fund-wallet/step-1",
  FUND_WALLET_STEP_2: "/api/user/fund-wallet/step-2",

  AIPRISE_KYC_FORM: "/api/user/aiprise/kyc/form",
  AIPRISE_KYC_FORM_SUBMIT: "/api/user/aiprise/kyc/form-submit",
  AIPRISE_KYC_DETAIL: "/api/user/aiprise/kyc/detail",

  // Didit KYC — all via the request helper (uses NEXT_PUBLIC_API_URL)
  DIDIT_KYC_FORM: "/api/user/didit/kyc/form",
  DIDIT_KYC_CREATE_SESSION: "/api/user/didit/kyc/create-session",
  DIDIT_KYC_SUBMIT: "/api/user/didit/kyc/form-submit",
  DIDIT_KYC_DETAIL: "/api/user/didit/kyc/detail",

  // Transaction PIN endpoints
  SET_TRANSACTION_PIN: "/api/user/transaction-pin/set",
  UPDATE_TRANSACTION_PIN: "/api/user/transaction-pin/update",
  VERIFY_TRANSACTION_PIN: "/api/user/transaction-pin/verify",
  GET_TRANSACTION_PIN_STATUS: "/api/user/transaction-pin/status",
  RESET_TRANSACTION_PIN: "/api/user/transaction-pin/reset",
  RESET_PIN_VIA_SECURITY_QUESTIONS:
    "/api/user/transaction-pin/reset/via-security-questions",
  STORE_TRANSACTION_PIN_RESET_REQUEST:
    "/api/user/transaction-pin/reset/store-transaction-pin-reset-request",
  CONFIRM_PIN_RESET: "/api/user/transaction-pin/reset/confirm",
  GET_SECURITY_QUESTIONS: "/api/user/get-security-questions",
  SET_SECURITY_QUESTIONS: "/api/user/set-security-questions",
  UPDATE_TRANSACTION_PIN_STATUS: "/api/user/transaction-pin/update",
  VERIFY_OTP: "/api/user/transaction-pin/reset/verify-otp",
  SEND_OTP: "/api/user/transaction-pin/send-otp",
  ENABLE_TRANSACTION_PIN: "/api/user/transaction-pin/enable",
  DISABLE_TRANSACTION_PIN: "/api/user/transaction-pin/disable",

  // =========================== Ipn ============================
  // ============================================================

  IPN: {
    stripe: "/ipn/stripe",
    authorize: "/ipn/authorize",
    nmi: "/ipn/nmi"
  },

  // =========================== Ipn ============================
  // ============================================================

  DEVICE_SESSIONS: "/api/device-sessions",
  DEVICE_SESSION_SINGLE: (id) => `/api/device-sessions/${id}`,
  DEVICE_SESSION_REGISTER: "/api/add-device-token",


  // =========================== Cross-border Payments ==========
  // ============================================================

  CROSSBORDER_BENEFICIARIES: (facility_type, receiving_country_id) => `/api/v2/cross-border-payments/beneficiaries?facility_type=${facility_type}&receiving_country_id=${receiving_country_id}`,
  CROSSBORDER_COUNTRIES: "/api/v2/cross-border-payments/recipient",
  CROSSBORDER_BENEFICIARY_FORM: (countryId, recipientType = 1, facilityType = null) =>
    `/api/v2/cross-border-payments/beneficiary-form?country_id=${countryId}&recipient_type=${recipientType}${facilityType ? `&facility_type=${facilityType}` : ''}`,
  NAME_ENQUIRY_V2: "/api/v2/cross-border-payments/name-enquiry",
  CROSSBORDER_CREATE_BENEFICIARIES: "/api/v2/cross-border-payments/beneficiaries",
  CROSSBORDER_DELETE_BENEFICIARY: (id) => `/api/v2/cross-border-payments/beneficiaries/${id}`,
  CROSSBORDER_AMOUNT: "/api/v2/cross-border-payments/amount",
  CROSSBORDER_OVERVIEW: (id) => `/api/v2/cross-border-payments/overview/${id}`,
  CROSSBORDER_PAYMENT_METHOD: (id) => `/api/v2/cross-border-payments/payment-methods/${id}`,
  CROSSBORDER_CONFIRM: `/api/v2/cross-border-payments/confirm`,
  CROSSBORDER_COUPON_APPLY: `/api/v2/cross-border-payments/coupon/apply`,
  CROSSBORDER_COUPON_REMOVE: `/api/v2/cross-border-payments/coupon/remove`,
  CROSSBORDER_PAYMENT_MADE: `/api/v2/cross-border-payments/payment-made`,
  CROSSBORDER_REPEAT: (id) => `/api/v2/cross-border-payments/repeat/${id}`,
  CROSSBORDER_REPEAT_POST: `/api/v2/cross-border-payments/repeat`,
  CROSSBORDER_TRANSACTION: `/api/v2/cross-border-payments/transactions`,
  CROSSBORDER_TRANSACTION_RECENT: (limit = 5) =>
    `/api/v2/cross-border-payments/transactions/recent?limit=${limit}`,
  CROSSBORDER_TRANSACTION_DETAILS: (id) => `/api/v2/cross-border-payments/details/${id}`,
  CROSSBORDER_RECEIPT: (idOrTrx) => `/api/v2/cross-border-payments/receipt/${idOrTrx}`,

  // =========================== Wallets ==========================
  // ============================================================

  WALLETS: "/api/v1/wallets",
  WALLET_DETAILS: (id) => `/api/v1/wallets/${id}/details`,
  REAL_ACCOUNT: (accountId) => `/api/v1/wallets/accounts/${accountId}`,
  WALLET_TRANSACTION_RECEIPT: (accountId, transactionId) =>
    `/api/v1/wallets/accounts/${accountId}/transactions/${transactionId}/receipt`,
  GENERATE_STATEMENT: (accountId, startDate, endDate) => `/api/v1/wallets/accounts/${accountId}/generate-statement?startDate=${startDate}&endDate=${endDate}`,
  WALLET_STATISTICS: (accountId) => `/api/v1/wallets/accounts/${accountId}/statistics`,
  WALLETS_CREATE: "/api/v1/wallets/create",
  WALLETS_ACCOUNTS: "/api/v1/wallets/accounts",
  WALLETS_SUPPORTED: "/api/v1/wallets/get-supported-wallets",
  GRIFFIN_PURPOSE_OF_ACCOUNT: "/api/griffin-purpose-of-account",
  GRIFFIN_SSE_STREAM: "/api/v1/wallets/griffin/events/stream",

  // =========================== Local Transfer ==================
  // ============================================================

  LOCAL_TRANSFER_RECIPIENTS: "/api/v2/local-transfer/beneficiaries",
  LOCAL_TRANSFER_BENEFICIARY_FORM: "/api/v2/local-transfer/beneficiary-form",
  LOCAL_TRANSFER_CREATE_BENEFICIARY: "/api/v2/local-transfer/beneficiaries",
  LOCAL_TRANSFER_VERIFY_ACCOUNT: "/api/v2/local-transfer/verify-account",
  LOCAL_TRANSFER_RECIPIENT: "/api/v2/local-transfer/recipient",
  LOCAL_TRANSFER_AMOUNT: "/api/v2/local-transfer/amount",
  LOCAL_TRANSFER_AMOUNT_BY_ID: (id) => `/api/v2/local-transfer/amount/${id}`,
  LOCAL_TRANSFER_OVERVIEW: "/api/v2/local-transfer/overview",
  LOCAL_TRANSFER_DETAILS: (id) => `/api/v2/local-transfer/details/${id}`,
  LOCAL_TRANSFER_CONFIRM: "/api/v2/local-transfer/confirm",
  LOCAL_TRANSFER_HISTORY: "/api/v2/local-transfer/history",
  LOCAL_TRANSFER_RECEIPT: (id) => `/api/v2/local-transfer/details/${id}/receipt`,

  // =========================== Belyfted Transfer ===============
  // ============================================================

  BELYFTED_TRANSFER_RECIPIENTS: "/api/v2/belyfted-transfer/recipient",
  BELYFTED_TRANSFER_SAVED_BENEFICIARIES: "/api/v2/belyfted-transfer/beneficiaries",
  BELYFTED_TRANSFER_AMOUNT: "/api/v2/belyfted-transfer/amount",
  BELYFTED_TRANSFER_CONFIRM: "/api/v2/belyfted-transfer/confirm",
  BELYFTED_TRANSFER_HISTORY: "/api/v2/belyfted-transfer/history",
  BELYFTED_TRANSFER_RECEIPT: (id) => `/api/v2/belyfted-transfer/details/${id}/receipt`,
  

  // =========================== KYB Onboarding ==================
  // ============================================================

  KYB_STEP1_SESSION: "/api/v1/onboarding/kyb/manual/step1/session",
  KYB_STEP1_PROCESS: "/api/v1/onboarding/kyb/manual/step1/process",
  KYB_STEP2_SESSION: "/api/v1/onboarding/kyb/manual/step2/session",
  KYB_STEP2_PROCESS: "/api/v1/onboarding/kyb/manual/step2/process",
  KYB_STEP3_SESSION: "/api/v1/onboarding/kyb/manual/step3/session",
  KYB_STEP3_PROCESS: "/api/v1/onboarding/kyb/manual/step3/process",
  KYB_STEP4_SESSION: "/api/v1/onboarding/kyb/manual/step4/session",
  KYB_STEP4_PROCESS: "/api/v1/onboarding/kyb/manual/step4/process",
  KYB_VERIFICATION_SESSION: "/api/v1/onboarding/kyb/manual/verification/session",

  // =========================== Business Metadata ================
  // ============================================================

  BUSINESS_MCC_LIST: "/api/list-business-mcc",
  BUSINESS_REG_TYPES: "/api/list-business-reg-types",

  // =========================== Misc ============================
  MARQUEE_DATA: "/api/section-data/marquee_content",
};

export default ENDPOINTS;
